// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/vision.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Page Background === */
.vision-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* replace xyz.jpg with your background */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  padding-bottom: 60px;
}

/* === Content Container === */
.vision-container {
  max-width: 1100px;
  width: 100%;
  margin: 120px auto 0 auto; /* space below navbar */
  /* background: rgba(255, 255, 255, 0.85); */
  border-radius: 16px;
  padding: 20px 40px;
  text-align: center;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(5px);
}

/* === Headings === */
.vision-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
}

.vision-intro {
  font-size: 1.1rem;
  color: #fff;
  margin-bottom: 50px;
  max-width: 750px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
}

/* === Vision & Mission Cards === */
.vision-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
}

.vision-card {
  background: rgba(3, 117, 76, 0.95);
  color: white;
  padding: 30px;
  border-radius: 16px;
  transition: transform 0.3s ease, background 0.3s ease;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
  text-align: center;
}

.vision-card img {
  width: 70px;
  height: 70px;
  margin-bottom: 15px;
}

.vision-card h3 {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 10px;
}

.vision-card p {
  font-size: 0.95rem;
  line-height: 1.6;
}

.vision-card:hover {
  transform: translateY(-5px);
  background: #025d3c;
}

/* === Responsive === */
@media (max-width: 768px) {
  .vision-container {
    padding: 40px 20px;
    margin-top: 100px;
  }

  .vision-title {
    font-size: 2rem;
  }

  .vision-card h3 {
    font-size: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AboutUs/VisionMission.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,yDAAmD,EAAE,yCAAyC;EAC9F,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB,EAAE,uBAAuB;EAClD,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* === Page Background === */\n.vision-page {\n  background-image: url(\"../../../public/vision.jpg\"); /* replace xyz.jpg with your background */\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n  padding-bottom: 60px;\n}\n\n/* === Content Container === */\n.vision-container {\n  max-width: 1100px;\n  width: 100%;\n  margin: 120px auto 0 auto; /* space below navbar */\n  /* background: rgba(255, 255, 255, 0.85); */\n  border-radius: 16px;\n  padding: 20px 40px;\n  text-align: center;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n  backdrop-filter: blur(5px);\n}\n\n/* === Headings === */\n.vision-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 10px;\n}\n\n.vision-intro {\n  font-size: 1.1rem;\n  color: #fff;\n  margin-bottom: 50px;\n  max-width: 750px;\n  margin-left: auto;\n  margin-right: auto;\n  line-height: 1.6;\n}\n\n/* === Vision & Mission Cards === */\n.vision-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 30px;\n}\n\n.vision-card {\n  background: rgba(3, 117, 76, 0.95);\n  color: white;\n  padding: 30px;\n  border-radius: 16px;\n  transition: transform 0.3s ease, background 0.3s ease;\n  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);\n  text-align: center;\n}\n\n.vision-card img {\n  width: 70px;\n  height: 70px;\n  margin-bottom: 15px;\n}\n\n.vision-card h3 {\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.vision-card p {\n  font-size: 0.95rem;\n  line-height: 1.6;\n}\n\n.vision-card:hover {\n  transform: translateY(-5px);\n  background: #025d3c;\n}\n\n/* === Responsive === */\n@media (max-width: 768px) {\n  .vision-container {\n    padding: 40px 20px;\n    margin-top: 100px;\n  }\n\n  .vision-title {\n    font-size: 2rem;\n  }\n\n  .vision-card h3 {\n    font-size: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
